<template>
    <div class="activate-wrapper">
        <a-result
            status="404"
            :title="$t('wp.wpIntegrationRequired')"
            :sub-title="$t('wp.wpRequiredIntegrationDescription')"
        >
            <template #extra>
                <a-button type="primary" @click="$router.push('/integrations/whatsapp')">
                    {{ $t("wp.integrateWp") }}
                </a-button>
            </template>
        </a-result>
    </div>
</template>

<script>
export default {
    name: "ActivateWhatsappAlert",
};
</script>

<style lang="scss">
.activate-wrapper {
    display: flex;
    justify-content: center;
    height: 100%;
    min-height: 100vh;
    width: 100%;
}
</style>
